import { reduxForm } from 'redux-form';
import LoginForm from './login-form';

const LoginFormContainer = reduxForm({
  form: 'authenticate',
})(LoginForm);

export default LoginFormContainer;
